<template>
  <div class="page-wrapper">
    <div class="page-inner">
      <div class="page-content-wrapper">
        <layout-header />

        <layout-body />

        <layout-footer />
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from './components/layout/Header.vue';
import LayoutBody from './components/layout/Body.vue';
import LayoutFooter from './components/layout/Footer.vue';

export default {
  components: {
    LayoutHeader,
    LayoutBody,
    LayoutFooter
  }
};
</script>
